;(function () {
  angular.module('contrast.filters').filter('linkMe', function () {
    var urlPattern =
      /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,()@?^=%&amp;:/~+#-]*[\w@?^)=%&amp;/~+#-])?/gi

    return function (text, target) {
      if (text) {
        return text.replace(
          urlPattern,
          '<a target="' + target + '" href="$&">$&</a>'
        )
      }
      return text
    }
  })
})()
